export const EMPTY_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<zeitgeist>
    <settings version="0.11" hue="220" language="de" region="DE" state="NI" calendar="iso8601" timezone="Europe/Berlin" />
    <dimensions>
    </dimensions>
    <timings>
    </timings>
    <relations>
    </relations>
    <creations>
    </creations>
    <capacities>
    </capacities>
    <conditions>
    </conditions>
    <metrics>
    </metrics>
    <objectives>
    </objectives>
    <fixations>
    </fixations>
    <adjustments>
    </adjustments>
</zeitgeist>
`;

export const MEDICAL_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<zeitgeist>
  <settings
    version="0.11"
    hue="32"
    language="de"
    region="DE"
    state="NI"
    calendar="iso8601"
    timezone="Europe/Berlin"
  />
  <dimensions>
    <dimension name="Wochentag" type="time.day">
      <point name="Mo" day_of_period="1" />
      <point name="Di" day_of_period="2" />
      <point name="Mi" day_of_period="3" />
      <point name="Do" day_of_period="4" />
      <point name="Fr" day_of_period="5" />
    </dimension>
    <dimension name="Zeitblock" type="time.slot" number_of_lanes="5">
      <point name="VM1" start_time="08:00" duration_minutes="90" />
      <point name="VM2" start_time="10:00" duration_minutes="90" />
      <point name="VM3" start_time="12:00" duration_minutes="90" />
      <point name="NM1" start_time="14:00" duration_minutes="90" />
      <point name="NM2" start_time="16:00" duration_minutes="90" />
    </dimension>
    <dimension name="MA" type="resource.person">
      <tag name="🩺 Fachärztlich" />
      <tag name="🩹 Ärztliche Weiterbildung" />
      <tag name="💬 Fachkonsultation" />
      <tag name="🥼🏥 Eingriffe" />
      <tag name="🥼💉 Injektionen" />
      <tag name="🥼👁️ Ambulanz" />
      <tag name="🥼🔬 Diagnostik 1" />
      <tag name="🥼🔬 Diagnostik 2" />
      <tag name="🥼🔬 Diagnostik 3" />
      <tag name="🥼🔬 Diagnostik 4" />
      <tag name="🥼🔬 Diagnostik 5" />
      <tag name="🥼✨ Laser" />
      <tag name="🥼🗂️ Organisation" />
      <point name="P001">
        <tagref name="🩹 Ärztliche Weiterbildung" />
        <tagref name="🥼👁️ Ambulanz" />
        <tagref name="🥼🔬 Diagnostik 1" />
        <tagref name="🥼🔬 Diagnostik 4" />
        <tagref name="🥼🔬 Diagnostik 2" />
        <tagref name="🥼🔬 Diagnostik 3" />
        <tagref name="🥼✨ Laser" />
      </point>
      <point name="P002">
        <tagref name="🩺 Fachärztlich" />
        <tagref name="🥼💉 Injektionen" />
        <tagref name="🥼🔬 Diagnostik 1" />
        <tagref name="🥼🔬 Diagnostik 5" />
        <tagref name="🥼🔬 Diagnostik 4" />
        <tagref name="🥼🔬 Diagnostik 2" />
        <tagref name="🥼🔬 Diagnostik 3" />
      </point>
      <point name="P003">
        <tagref name="🩺 Fachärztlich" />
        <tagref name="🥼💉 Injektionen" />
      </point>
      <point name="P004">
        <tagref name="🥼🏥 Eingriffe" />
      </point>
      <point name="P005">
        <tagref name="🥼🏥 Eingriffe" />
      </point>
      <point name="P006">
        <tagref name="🩺 Fachärztlich" />
        <tagref name="🥼💉 Injektionen" />
        <tagref name="🥼🔬 Diagnostik 1" />
        <tagref name="🥼🔬 Diagnostik 5" />
        <tagref name="🥼🗂️ Organisation" />
        <tagref name="🥼🔬 Diagnostik 4" />
        <tagref name="🥼🔬 Diagnostik 2" />
        <tagref name="🥼🔬 Diagnostik 3" />
        <tagref name="🥼✨ Laser" />
      </point>
      <point name="P007">
        <tagref name="💬 Fachkonsultation" />
        <tagref name="🥼👁️ Ambulanz" />
        <tagref name="🥼🔬 Diagnostik 1" />
        <tagref name="🥼🔬 Diagnostik 2" />
      </point>
      <point name="P008">
        <tagref name="🥼🏥 Eingriffe" />
        <tagref name="🥼🔬 Diagnostik 1" />
      </point>
      <point name="P009" />
    </dimension>
    <dimension name="Ressource" type="resource.place">
      <point name="🏥 Eingriffe" hue="214" />
      <point name="💉 Injektionen" hue="188" />
      <point name="👁️ Ambulanz" hue="336" />
      <point name="🔬 Diagnostik 1" hue="250" />
      <point name="🔬 Diagnostik 2" hue="90" />
      <point name="🔬 Diagnostik 3" hue="0" />
      <point name="🔬 Diagnostik 4" hue="100" />
      <point name="🔬 Diagnostik 5" hue="80" />
      <point name="✨ Laser" hue="140" />
      <point name="🤝 Assistenz Eingriffe" hue="213" />
      <point name="🤝 Assistenz Diagnostik" hue="80" />
      <point name="🗂️ Organisation" chroma="-20" />
    </dimension>
  </dimensions>
  <relations>
    <relation type="connection" name="🥼↔️🏥 Eingriffe">
      <dimref name="Ressource">
        <pointref name="🏥 Eingriffe" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🏥 Eingriffe" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🏥 Eingriffe">
      <dimref name="Ressource">
        <pointref name="🏥 Eingriffe" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="VM1" />
        <pointref name="VM2" />
        <pointref name="VM3" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️💉 Injektionen">
      <dimref name="Ressource">
        <pointref name="💉 Injektionen" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼💉 Injektionen" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️💉 Injektionen">
      <dimref name="Ressource">
        <pointref name="💉 Injektionen" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="NM1" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️👁️ Ambulanz">
      <dimref name="Ressource">
        <pointref name="👁️ Ambulanz" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼👁️ Ambulanz" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️👁️ Ambulanz">
      <dimref name="Ressource">
        <pointref name="👁️ Ambulanz" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="NM1" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🔬 Diagnostik 1">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🔬 Diagnostik 1" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🔬 Diagnostik 1">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="Zeitblock">
        <allpoints />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🔬 Diagnostik 2">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🔬 Diagnostik 2" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🔬 Diagnostik 2">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="Zeitblock">
        <allpoints />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🔬 Diagnostik 3">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 3" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🔬 Diagnostik 3" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🔬 Diagnostik 3">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 3" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="VM1" />
        <pointref name="VM2" />
        <pointref name="VM3" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🔬 Diagnostik 4">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 4" />
      </dimref>
      <dimref name="MA">
        <pointref name="P009" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🔬 Diagnostik 4">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 4" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="VM1" />
        <pointref name="VM2" />
        <pointref name="VM3" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🔬 Diagnostik 5">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🔬 Diagnostik 5" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🔬 Diagnostik 5">
      <dimref name="Ressource">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
      <dimref name="Zeitblock">
        <pointref name="VM3" />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️✨ Laser">
      <dimref name="Ressource">
        <pointref name="✨ Laser" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼✨ Laser" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️✨ Laser">
      <dimref name="Ressource">
        <pointref name="✨ Laser" />
      </dimref>
      <dimref name="Zeitblock">
        <allpoints />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🤝 Assistenz">
      <dimref name="Ressource">
        <pointref name="🤝 Assistenz Eingriffe" />
        <pointref name="🤝 Assistenz Diagnostik" />
      </dimref>
      <dimref name="MA">
        <tagref name="🩹 Ärztliche Weiterbildung" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🤝 Assistenz">
      <dimref name="Ressource">
        <pointref name="🤝 Assistenz Eingriffe" />
        <pointref name="🤝 Assistenz Diagnostik" />
      </dimref>
      <dimref name="Zeitblock">
        <allpoints />
      </dimref>
    </relation>
    <relation type="connection" name="🥼↔️🗂️ Organisation">
      <dimref name="Ressource">
        <pointref name="🗂️ Organisation" />
      </dimref>
      <dimref name="MA">
        <tagref name="🥼🗂️ Organisation" />
      </dimref>
    </relation>
    <relation type="connection" name="🕖↔️🗂️ Organisation">
      <dimref name="Ressource">
        <pointref name="🗂️ Organisation" />
      </dimref>
      <dimref name="Zeitblock">
        <allpoints />
      </dimref>
    </relation>
  </relations>
  <creations>
    <creation name="3 💉 Injektionen" equal="3" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="💉 Injektionen" />
      </dimref>
    </creation>
    <creation name="1 🔬 Diagnostik 3 pro Tag" equal="1" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🔬 Diagnostik 3" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
    </creation>
    <creation name="15 🔬 Diagnostik 2" equal="15" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
    </creation>
    <creation name="3 🏥 Eingriffe pro Tag" equal="3" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🏥 Eingriffe" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
    </creation>
    <creation name="13 🔬 Diagnostik 1" equal="13" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
    </creation>
    <creation name="6 🔬 Diagnostik 4" equal="6" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🔬 Diagnostik 4" />
      </dimref>
    </creation>
    <creation name="2 🔬 Diagnostik 5" equal="2" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
    </creation>
    <creation name="2 ✨ Laser" equal="2" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="✨ Laser" />
      </dimref>
    </creation>
    <creation name="4 🤝 Assistenz Eingriffe 🥼 P001" equal="4" enforcement="hard" connect="false">
      <dimref name="Ressource" role="make">
        <pointref name="🤝 Assistenz Eingriffe" />
      </dimref>
      <dimref name="MA" role="make">
        <pointref name="P001" />
      </dimref>
    </creation>
  </creations>
  <capacities>
  </capacities>
  <conditions>
    <condition type="distinct" name="gleiche/r Operateur/in pro Tag" enforcement="off" group="Organisation" max="1">
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="MA" role="on">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="🏥 Eingriffe" />
      </dimref>
    </condition>
    <condition type="count" name="Praxis Freitag Nachmittag zu" enforcement="off" group="Organisation" equal="0">
      <dimref name="Wochentag" role="for">
        <pointref name="Fr" />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <pointref name="NM1" />
        <pointref name="NM2" />
      </dimref>
    </condition>
    <condition type="count" name="💉 Injektionen Di-Do" enforcement="off" group="Organisation" equal="0">
      <dimref name="Wochentag" role="for">
        <pointref name="Mo" />
        <pointref name="Fr" />
      </dimref>
      <dimref name="Ressource" role="for">
        <pointref name="💉 Injektionen" />
      </dimref>
    </condition>
    <condition type="distinct" name="🔬 Diagnostik 4 und 5 nicht gleichzeitig" enforcement="off" group="Organisation" max="1">
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="on">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="🔬 Diagnostik 4" />
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
    </condition>
    <condition type="count" name="VM3 außer Di max 3 Behandlungen gleichzeitig" enforcement="off" group="Organisation" max="3">
      <dimref name="Wochentag" role="for">
        <pointref name="Mo" />
        <pointref name="Mi" />
        <pointref name="Do" />
        <pointref name="Fr" />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <pointref name="VM3" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
        <pointref name="🔬 Diagnostik 1" />
        <pointref name="🔬 Diagnostik 2" />
        <pointref name="🔬 Diagnostik 3" />
        <pointref name="🔬 Diagnostik 5" />
        <pointref name="✨ Laser" />
      </dimref>
    </condition>
    <condition type="count" name="VM3 Di max 2 Behandlungen gleichzeitig" enforcement="off" group="Organisation" max="2">
      <dimref name="Wochentag" role="for">
        <pointref name="Di" />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <pointref name="VM3" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
        <pointref name="🔬 Diagnostik 1" />
        <pointref name="🔬 Diagnostik 2" />
        <pointref name="🔬 Diagnostik 3" />
        <pointref name="🔬 Diagnostik 5" />
        <pointref name="✨ Laser" />
      </dimref>
    </condition>
    <condition type="count" name="nicht VM3 max 2 Behandlungen gleichzeitig" enforcement="off" group="Organisation" max="2">
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <pointref name="VM1" />
        <pointref name="VM2" />
        <pointref name="NM1" />
        <pointref name="NM2" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
        <pointref name="🔬 Diagnostik 1" />
        <pointref name="🔬 Diagnostik 2" />
        <pointref name="🔬 Diagnostik 3" />
        <pointref name="🔬 Diagnostik 5" />
        <pointref name="✨ Laser" />
      </dimref>
    </condition>
    <condition type="distinct" name="💉 Injektionen und 🔬 Diagnostik 1 nicht gleichzeitig" enforcement="off" group="Organisation" max="1">
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="for">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="on">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
    </condition>
    <condition type="count" name="🔬 Diagnostik 5 nicht Di" enforcement="off" group="Organisation" equal="0">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Di" />
      </dimref>
    </condition>
    <condition type="count" name="🔬 Diagnostik 5 nicht Fr" enforcement="off" group="Organisation" equal="0">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Fr" />
      </dimref>
    </condition>
    <condition type="distinct" name="🔬 Diagnostik 5 zwei verschiedene MA" enforcement="off" group="Organisation" equal="2">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 5" />
      </dimref>
      <dimref name="MA" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="distinct" name="✨ Laser zwei verschiedene MA" enforcement="off" group="Organisation" equal="2">
      <dimref name="Ressource" role="for">
        <pointref name="✨ Laser" />
      </dimref>
      <dimref name="MA" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="P001 Wochenstunden" enforcement="off" group="MA Stunden" max="20">
      <dimref name="MA" role="for">
        <pointref name="P001" />
      </dimref>
    </condition>
    <condition type="count" name="P002 Wochenstunden" enforcement="off" group="MA Stunden" max="10">
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
    </condition>
    <condition type="count" name="P003 Wochenstunden" enforcement="off" group="MA Stunden" max="1">
      <dimref name="MA" role="for">
        <pointref name="P003" />
      </dimref>
    </condition>
    <condition type="count" name="P004 Wochenstunden" enforcement="off" group="MA Stunden" max="10">
      <dimref name="MA" role="for">
        <pointref name="P004" />
      </dimref>
    </condition>
    <condition type="count" name="P005 Wochenstunden" enforcement="off" group="MA Stunden" max="10">
      <dimref name="MA" role="for">
        <pointref name="P005" />
      </dimref>
    </condition>
    <condition type="count" name="P006 Wochenstunden" enforcement="off" group="MA Stunden" max="13">
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
    </condition>
    <condition type="count" name="P007 Wochenstunden" enforcement="off" group="MA Stunden" max="5">
      <dimref name="MA" role="for">
        <pointref name="P007" />
      </dimref>
    </condition>
    <condition type="count" name="3 🔬 Diagnostik 1 P006" enforcement="off" group="MA Einsätze" equal="3">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
    </condition>
    <condition type="count" name="2 🔬 Diagnostik 1 P002" enforcement="off" group="MA Einsätze" equal="2">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
    </condition>
    <condition type="count" name="4 🔬 Diagnostik 1 P001" enforcement="off" group="MA Einsätze" equal="4">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P001" />
      </dimref>
    </condition>
    <condition type="count" name="2 🔬 Diagnostik 1 P007" enforcement="off" group="MA Einsätze" equal="2">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P007" />
      </dimref>
    </condition>
    <condition type="count" name="1 🔬 Diagnostik 1 P008" enforcement="off" group="MA Einsätze" min="1">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 1" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P008" />
      </dimref>
    </condition>
    <condition type="count" name="2+ 🔬 Diagnostik 2 P002" enforcement="off" group="MA Einsätze" min="2">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
    </condition>
    <condition type="count" name="5 🔬 Diagnostik 2 P002" enforcement="off" group="MA Einsätze" equal="5">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
    </condition>
    <condition type="count" name="6- 🔬 Diagnostik 2 P006" enforcement="off" group="MA Einsätze" max="6">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
    </condition>
    <condition type="count" name="1 🔬 Diagnostik 2 P007" enforcement="off" group="MA Einsätze" equal="1">
      <dimref name="Ressource" role="for">
        <pointref name="🔬 Diagnostik 2" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P007" />
      </dimref>
    </condition>
    <condition type="count" name="4- 🤝 Assistenz Eingriffe P001" enforcement="off" group="MA Einsätze" max="4">
      <dimref name="Ressource" role="for">
        <pointref name="🤝 Assistenz Eingriffe" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P001" />
      </dimref>
    </condition>
    <condition type="count" name="3 🏥 Eingriffe P008" enforcement="off" group="MA Einsätze" equal="3">
      <dimref name="Ressource" role="for">
        <pointref name="🏥 Eingriffe" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P008" />
      </dimref>
    </condition>
    <condition type="count" name="6 🏥 Eingriffe P004" enforcement="off" group="MA Einsätze" equal="6">
      <dimref name="Ressource" role="for">
        <pointref name="🏥 Eingriffe" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P004" />
      </dimref>
    </condition>
    <condition type="count" name="P001 🤝 Assistenz Eingriffe nicht VM3-NM2" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="Zeitblock" role="for">
        <pointref name="VM3" />
        <pointref name="NM1" />
        <pointref name="NM2" />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P001" />
      </dimref>
      <dimref name="Ressource" role="for">
        <pointref name="🤝 Assistenz Eingriffe" />
      </dimref>
    </condition>
    <condition type="distinct" name="P001 🤝 Assistenz Eingriffe an zwei versch. Wochentagen" enforcement="off" group="MA Wünsche" equal="2">
      <dimref name="MA" role="for">
        <pointref name="P001" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="🤝 Assistenz Eingriffe" />
      </dimref>
    </condition>
    <condition type="count" name="P002 🔬 Diagnostik 2 nicht Di-Mi" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Di" />
        <pointref name="Mi" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
      </dimref>
    </condition>
    <condition type="count" name="P003 💉 Injektionen nicht Mi-Do" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P003" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Mi" />
        <pointref name="Do" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
      </dimref>
    </condition>
    <condition type="count" name="P004 Do-Fr frei" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P004" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Do" />
        <pointref name="Fr" />
      </dimref>
    </condition>
    <condition type="count" name="P005 Mo frei" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P005" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Mo" />
      </dimref>
    </condition>
    <condition type="count" name="P006 💉 Injektionen nicht Di, Do" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Di" />
        <pointref name="Do" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="💉 Injektionen" />
      </dimref>
    </condition>
    <condition type="distinct" name="P002 3 Tage pro Woche" enforcement="off" group="MA Wünsche" equal="3">
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="distinct" name="P006 4 Tage pro Woche" enforcement="off" group="MA Wünsche" max="4">
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="P006 Fr frei" enforcement="off" group="MA Wünsche" equal="0">
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Fr" />
      </dimref>
    </condition>
    <condition type="distinct" name="P007 3 Tage pro Woche" enforcement="off" group="MA Wünsche" max="3">
      <dimref name="MA" role="for">
        <pointref name="P007" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="block" name="MA täglich in einem Block" enforcement="off" group="MA Wünsche" equal="1">
      <dimref name="MA" role="for">
        <allpoints />
      </dimref>
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="P008 🏥 Eingriffe nicht Mo, Di, Do, Fr" enforcement="off" group="MA Wünsche" max="0">
      <dimref name="MA" role="for">
        <pointref name="P008" />
      </dimref>
      <dimref name="Wochentag" role="for">
        <pointref name="Mo" />
        <pointref name="Di" />
        <pointref name="Do" />
        <pointref name="Fr" />
      </dimref>
      <dimref name="Ressource" role="where">
        <pointref name="🏥 Eingriffe" />
      </dimref>
    </condition>
    <condition type="distinct" name="P006 nur einen NM pro Woche" enforcement="off" group="MA Wünsche" equal="1">
      <dimref name="MA" role="for">
        <pointref name="P006" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="where">
        <pointref name="NM1" />
        <pointref name="NM2" />
      </dimref>
    </condition>
    <condition type="distinct" name="P002 nur einen NM pro Woche" enforcement="off" group="MA Wünsche" equal="1">
      <dimref name="MA" role="for">
        <pointref name="P002" />
      </dimref>
      <dimref name="Wochentag" role="on">
        <allpoints />
      </dimref>
      <dimref name="Zeitblock" role="where">
        <pointref name="NM1" />
        <pointref name="NM2" />
      </dimref>
    </condition>
    <condition type="count" name="P001, P002, P006 nicht nur 1 Schicht pro Tag" enforcement="off" group="MA Wünsche" not_equal="1">
      <dimref name="Wochentag" role="for">
        <allpoints />
      </dimref>
      <dimref name="MA" role="for">
        <pointref name="P001" />
        <pointref name="P002" />
        <pointref name="P006" />
      </dimref>
    </condition>
  </conditions>
</zeitgeist>
`;


export const TEACHING_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<zeitgeist>
  <settings
    version="0.11"
    hue="220"
    language="de"
    region="DE"
    state="NI"
    calendar="iso8601"
    timezone="Europe/Berlin"
  />
  <dimensions>
    <dimension name="Tag" type="time.day">
      <point name="Montag" day_of_period="1" />
      <point name="Dienstag" day_of_period="2" />
      <point name="Mittwoch" day_of_period="3" />
      <point name="Donnerstag" day_of_period="4" />
      <point name="Freitag" day_of_period="5" />
    </dimension>
    <dimension name="Zeit" type="time.slot">
      <point name="1." start_time="08:00" duration_minutes="45" />
      <point name="2." start_time="08:50" duration_minutes="45" />
      <point name="3." start_time="09:55" duration_minutes="45" />
    </dimension>
    <dimension name="Klasse" type="resource.team">
      <tag name="Musik-Klassen" />
      <tag name="Sport-Klassen" />
      <point name="Klasse 1a">
        <tagref name="Musik-Klassen" />
      </point>
      <point name="Klasse 2a">
        <tagref name="Musik-Klassen" />
      </point>
      <point name="Klasse 3a">
        <tagref name="Sport-Klassen" />
      </point>
    </dimension>
    <dimension name="Lehrkraft" type="resource.person">
      <point name="Frau Ast" lightness="3" />
      <point name="Herr Baum" lightness="-3" />
      <point name="Dr. Stamm" chroma="5" />
    </dimension>
    <dimension name="Raum" type="resource.place">
      <tag name="Klassenräume" />
      <tag name="Fachräume" />
      <tag name="Sportstätten" />
      <point name="Klassenraum1">
        <tagref name="Klassenräume" />
      </point>
      <point name="Klassenraum2">
        <tagref name="Klassenräume" />
      </point>
      <point name="Klassenraum3">
        <tagref name="Klassenräume" />
      </point>
      <point name="Musikraum">
        <tagref name="Fachräume" />
      </point>
      <point name="Sporthalle">
        <tagref name="Sportstätten" />
      </point>
    </dimension>
    <dimension name="Fach">
      <tag name="Hauptfächer" />
      <tag name="Kernfächer" />
      <point name="✏️ Deutsch" hue="120">
        <tagref name="Hauptfächer" />
        <tagref name="Kernfächer" />
      </point>
      <point name="🧮 Mathematik" hue="140">
        <tagref name="Hauptfächer" />
        <tagref name="Kernfächer" />
      </point>
      <point name="🌷 Sachkunde" hue="160">
        <tagref name="Hauptfächer" />
      </point>
      <point name="⚽️ Sport" hue="180" />
      <point name="🎸 Musik" hue="200" />
      <point name="🎶 Chor" hue="210" />
    </dimension>
  </dimensions>
  <relations>
    <relation type="connection" name="Frau Ast und Herr Baum für Deutsch, Sachkunde und Sport">
      <dimref name="Lehrkraft">
        <pointref name="Frau Ast" />
        <pointref name="Herr Baum" />
      </dimref>
      <dimref name="Fach">
        <pointref name="🌷 Sachkunde" />
        <pointref name="✏️ Deutsch" />
        <pointref name="⚽️ Sport" />
      </dimref>
    </relation>
    <relation type="connection" name="Dr. Stamm für Mathematik, Musik und Chor">
      <dimref name="Lehrkraft">
        <pointref name="Dr. Stamm" />
      </dimref>
      <dimref name="Fach">
        <pointref name="🧮 Mathematik" />
        <pointref name="🎸 Musik" />
        <pointref name="🎶 Chor" />
      </dimref>
    </relation>
    <relation type="connection" name="Fachräume und Sportstätten für alle Klassen">
      <dimref name="Klasse">
        <allpoints />
      </dimref>
      <dimref name="Raum">
        <tagref name="Fachräume" />
        <tagref name="Sportstätten" />
      </dimref>
    </relation>
    <relation type="connection" name="Klassenraum1 nur für Klasse 1a">
      <dimref name="Klasse">
        <pointref name="Klasse 1a" />
      </dimref>
      <dimref name="Raum">
        <pointref name="Klassenraum1" />
      </dimref>
    </relation>
    <relation type="connection" name="Klassenraum2 nur für Klasse 2a">
      <dimref name="Klasse">
        <pointref name="Klasse 2a" />
      </dimref>
      <dimref name="Raum">
        <pointref name="Klassenraum2" />
      </dimref>
    </relation>
    <relation type="connection" name="Klassenraum3 nur für Klasse 3a">
      <dimref name="Klasse">
        <pointref name="Klasse 3a" />
      </dimref>
      <dimref name="Raum">
        <pointref name="Klassenraum3" />
      </dimref>
    </relation>
    <relation type="connection" name="Klassenräume und Fachräume an jedem Tag">
      <dimref name="Tag">
        <allpoints />
      </dimref>
      <dimref name="Raum">
        <tagref name="Klassenräume" />
        <tagref name="Fachräume" />
      </dimref>
    </relation>
    <relation type="connection" name="Sporthalle nur Mi Do Fr">
      <dimref name="Tag">
        <pointref name="Mittwoch" />
        <pointref name="Donnerstag" />
        <pointref name="Freitag" />
      </dimref>
      <dimref name="Raum">
        <pointref name="Sporthalle" />
      </dimref>
    </relation>
    <relation type="connection" name="Hauptfächer in Klassenräumen">
      <dimref name="Raum">
        <tagref name="Klassenräume" />
      </dimref>
      <dimref name="Fach">
        <tagref name="Hauptfächer" />
      </dimref>
    </relation>
    <relation type="connection" name="Musik und Chor im Musikraum">
      <dimref name="Raum">
        <pointref name="Musikraum" />
      </dimref>
      <dimref name="Fach">
        <pointref name="🎸 Musik" />
        <pointref name="🎶 Chor" />
      </dimref>
    </relation>
    <relation type="connection" name="Sport in der Sporthalle">
      <dimref name="Raum">
        <pointref name="Sporthalle" />
      </dimref>
      <dimref name="Fach">
        <pointref name="⚽️ Sport" />
      </dimref>
    </relation>
    <relation type="disconnection" name="Sporthalle nicht 1. Stunde">
      <dimref name="Tag">
        <pointref name="Mittwoch" />
        <pointref name="Donnerstag" />
      </dimref>
      <dimref name="Zeit">
        <pointref name="1." />
      </dimref>
      <dimref name="Raum">
        <pointref name="Sporthalle" />
      </dimref>
    </relation>
  </relations>
  <creations>
    <creation name="Deutsch: 4 Stunden pro Klasse" equal="4" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="✏️ Deutsch" />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
    </creation>
    <creation name="Mathematik: 3 Stunden pro Klasse" equal="3" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="🧮 Mathematik" />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
    </creation>
    <creation name="Sachkunde: 2 Stunden pro Klasse" equal="2" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="🌷 Sachkunde" />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
    </creation>
    <creation name="Sport: 3 Stunden für Sport-Klassen" equal="3" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="⚽️ Sport" />
      </dimref>
      <dimref name="Klasse" role="for">
        <tagref name="Sport-Klassen" />
      </dimref>
    </creation>
    <creation name="Musik: 1 Stunde für Sport-Klassen" equal="1" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="🎸 Musik" />
      </dimref>
      <dimref name="Klasse" role="for">
        <tagref name="Sport-Klassen" />
      </dimref>
    </creation>
    <creation name="Sport: 2 Stunden für Musik-Klassen" equal="2" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="⚽️ Sport" />
      </dimref>
      <dimref name="Klasse" role="for">
        <tagref name="Musik-Klassen" />
      </dimref>
    </creation>
    <creation name="Musik: 2 Stunden für Musik-Klassen" equal="2" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="🎸 Musik" />
      </dimref>
      <dimref name="Klasse" role="for">
        <tagref name="Musik-Klassen" />
      </dimref>
    </creation>
    <creation name="Chor: 1 Stunde pro Klasse" equal="1" enforcement="hard" connect="true">
      <dimref name="Fach" role="make">
        <pointref name="🎶 Chor" />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
    </creation>
  </creations>
  <capacities>
    <capacity name="Dr. Stamm: 3 Klassen für Chor" limit="3">
      <dimref name="Lehrkraft" role="for">
        <pointref name="Dr. Stamm" />
      </dimref>
      <dimref name="Fach" role="where">
        <pointref name="🎶 Chor" />
      </dimref>
    </capacity>
    <capacity name="Musikraum: 3 Klassen für Chor" limit="3">
      <dimref name="Raum" role="for">
        <pointref name="Musikraum" />
      </dimref>
      <dimref name="Fach" role="where">
        <pointref name="🎶 Chor" />
      </dimref>
    </capacity>
  </capacities>
  <conditions>
    <condition type="distinct" name="in jeder Klasse höchstens eine Lehrkraft pro Fach" enforcement="soft" group="Pädagogik" max="1">
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Fach" role="for">
        <allpoints />
      </dimref>
      <dimref name="Lehrkraft" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="täglich höchstens 2 Stunden eines Faches" enforcement="soft" group="Pädagogik" max="2">
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Fach" role="for">
        <allpoints />
      </dimref>
    </condition>
    <condition type="distinct" name="Klassen bekommen mehrere Lehrkräfte" enforcement="soft" group="Pädagogik" min="2">
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Lehrkraft" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="block" name="Fächer zusammenhängend pro Tag" enforcement="soft" group="Pädagogik" equal="1">
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Fach" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeit" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="Musik nicht als Einzelstunde in Musik-Klassen" enforcement="soft" group="Pädagogik" not_equal="1">
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Klasse" role="for">
        <tagref name="Musik-Klassen" />
      </dimref>
      <dimref name="Fach" role="where">
        <pointref name="🎸 Musik" />
      </dimref>
    </condition>
    <condition type="count" name="Sport nicht als Einzelstunde" enforcement="soft" group="Pädagogik" not_equal="1">
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Fach" role="where">
        <pointref name="⚽️ Sport" />
      </dimref>
    </condition>
    <condition type="count" name="Klassen mindestens 2 Stunden täglich" enforcement="soft" group="Organisation" min="2">
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
    </condition>
    <condition type="gap" name="Klassen keine Hohlstunden" enforcement="soft" group="Organisation" equal="0">
      <dimref name="Klasse" role="for">
        <allpoints />
      </dimref>
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeit" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="align" name="Klassen gleichzeitig Chor" enforcement="soft" group="Organisation" equal="1">
      <participants>
        <participant>
          <dimref name="Klasse">
            <pointref name="Klasse 1a" />
          </dimref>
          <dimref name="Fach">
            <pointref name="🎶 Chor" />
          </dimref>
        </participant>
        <participant>
          <dimref name="Klasse">
            <pointref name="Klasse 2a" />
          </dimref>
          <dimref name="Fach">
            <pointref name="🎶 Chor" />
          </dimref>
        </participant>
        <participant>
          <dimref name="Klasse">
            <pointref name="Klasse 3a" />
          </dimref>
          <dimref name="Fach">
            <pointref name="🎶 Chor" />
          </dimref>
        </participant>
      </participants>
      <dimref name="Tag" role="on">
        <allpoints />
      </dimref>
      <dimref name="Zeit" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="Lehrkräfte mindestens 8 Wochenstunden" group="Wünsche der Lehrkräfte" min="8">
      <dimref name="Lehrkraft" role="for">
        <allpoints />
      </dimref>
    </condition>
    <condition type="distinct" name="Lehrkräfte nicht nur 1 Stunde am Tag" enforcement="soft" group="Wünsche der Lehrkräfte" not_equal="1">
      <dimref name="Lehrkraft" role="for">
        <allpoints />
      </dimref>
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeit" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="gap" name="Lehrkraft keine Hohlstunden" enforcement="soft" group="Wünsche der Lehrkräfte" equal="0">
      <dimref name="Lehrkraft" role="for">
        <allpoints />
      </dimref>
      <dimref name="Tag" role="for">
        <allpoints />
      </dimref>
      <dimref name="Zeit" role="on">
        <allpoints />
      </dimref>
    </condition>
    <condition type="count" name="Herr Baum freitags frei" enforcement="soft" group="Wünsche der Lehrkräfte" equal="0">
      <dimref name="Tag" role="for">
        <pointref name="Freitag" />
      </dimref>
      <dimref name="Lehrkraft" role="where">
        <pointref name="Herr Baum" />
      </dimref>
    </condition>
  </conditions>
</zeitgeist>`;


export const SUDOKU_TEMPLATE = `<?xml version="1.0" encoding="UTF-8"?>
<zeitgeist>
    <settings version="0.11" hue="100" language="de" region="DE" state="NI" calendar="iso8601" timezone="Europe/Berlin" />
    <dimensions>
        <dimension name="Spalten">
            <tag name="SB1" />
            <tag name="SB2" />
            <tag name="SB3" />
            <point name="S1">
                <tagref name="SB1" />
            </point>
            <point name="S2">
                <tagref name="SB1" />
            </point>
            <point name="S3">
                <tagref name="SB1" />
            </point>
            <point name="S4">
                <tagref name="SB2" />
            </point>
            <point name="S5">
                <tagref name="SB2" />
            </point>
            <point name="S6">
                <tagref name="SB2" />
            </point>
            <point name="S7">
                <tagref name="SB3" />
            </point>
            <point name="S8">
                <tagref name="SB3" />
            </point>
            <point name="S9">
                <tagref name="SB3" />
            </point>
        </dimension>
        <dimension name="Zeilen">
            <tag name="ZB1" />
            <tag name="ZB2" />
            <tag name="ZB3" />
            <point name="Z1">
                <tagref name="ZB1" />
            </point>
            <point name="Z2">
                <tagref name="ZB1" />
            </point>
            <point name="Z3">
                <tagref name="ZB1" />
            </point>
            <point name="Z4">
                <tagref name="ZB2" />
            </point>
            <point name="Z5">
                <tagref name="ZB2" />
            </point>
            <point name="Z6">
                <tagref name="ZB2" />
            </point>
            <point name="Z7">
                <tagref name="ZB3" />
            </point>
            <point name="Z8">
                <tagref name="ZB3" />
            </point>
            <point name="Z9">
                <tagref name="ZB3" />
            </point>
        </dimension>
        <dimension name="Ziffern">
            <point name="1️⃣" hue="0">
            </point>
            <point name="2️⃣" hue="40">
            </point>
            <point name="3️⃣" hue="80">
            </point>
            <point name="4️⃣" hue="120">
            </point>
            <point name="5️⃣" hue="160">
            </point>
            <point name="6️⃣" hue="200">
            </point>
            <point name="7️⃣" hue="240">
            </point>
            <point name="8️⃣" hue="280">
            </point>
            <point name="9️⃣" hue="320">
            </point>
        </dimension>
        <dimension name="Blöcke">
            <point name="₁" chroma="0">
            </point>
            <point name="₂" chroma="20">
            </point>
            <point name="₃">
            </point>
            <point name="₄" chroma="20">
            </point>
            <point name="₅">
            </point>
            <point name="₆" chroma="20">
            </point>
            <point name="₇">
            </point>
            <point name="₈" chroma="20">
            </point>
            <point name="₉">
            </point>
        </dimension>
    </dimensions>
    <relations>
        <relation type="connection" name="R11">
            <dimref name="Spalten">
                <tagref name="SB1" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB1" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₁" />
            </dimref>
        </relation>
        <relation type="connection" name="R12">
            <dimref name="Spalten">
                <tagref name="SB2" />
                <tagref name="SB1" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB2" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₂" />
            </dimref>
        </relation>
        <relation type="connection" name="R13">
            <dimref name="Spalten">
                <tagref name="SB1" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB3" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₃" />
            </dimref>
        </relation>
        <relation type="connection" name="R21">
            <dimref name="Spalten">
                <tagref name="SB2" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB1" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₄" />
            </dimref>
        </relation>
        <relation type="connection" name="R22">
            <dimref name="Spalten">
                <tagref name="SB2" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB2" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₅" />
            </dimref>
        </relation>
        <relation type="connection" name="R23">
            <dimref name="Spalten">
                <tagref name="SB2" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB3" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₆" />
            </dimref>
        </relation>
        <relation type="connection" name="R31">
            <dimref name="Spalten">
                <tagref name="SB3" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB1" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₇" />
            </dimref>
        </relation>
        <relation type="connection" name="R32">
            <dimref name="Spalten">
                <tagref name="SB3" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB2" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₈" />
            </dimref>
        </relation>
        <relation type="connection" name="R33">
            <dimref name="Spalten">
                <tagref name="SB3" />
            </dimref>
            <dimref name="Zeilen">
                <tagref name="ZB3" />
            </dimref>
            <dimref name="Blöcke">
                <pointref name="₉" />
            </dimref>
        </relation>
    </relations>
    <creations>
        <creation name="81 Kandidaten erzeugen" equal="81" connect="false">
            <dimref name="Ziffern" role="make">
                <allpoints />
            </dimref>
        </creation>
    </creations>
    <conditions>
        <condition type="count" name="pro Zelle genau 1 Ziffer" group="Sudoku-Regeln" equal="1">
            <dimref name="Spalten" role="for">
                <allpoints />
            </dimref>
            <dimref name="Zeilen" role="for">
                <allpoints />
            </dimref>
        </condition>
        <condition type="distinct" name="pro Spalte 9 verschiedene Ziffern" group="Sudoku-Regeln" equal="9">
            <dimref name="Ziffern" role="on">
                <allpoints />
            </dimref>
            <dimref name="Spalten" role="for">
                <allpoints />
            </dimref>
        </condition>
        <condition type="distinct" name="pro Zeile  9 verschiedene Ziffern" group="Sudoku-Regeln" equal="9">
            <dimref name="Ziffern" role="on">
                <allpoints />
            </dimref>
            <dimref name="Zeilen" role="for">
                <allpoints />
            </dimref>
        </condition>
        <condition type="distinct" name="pro Block  9 verschiedene Ziffern" group="Sudoku-Regeln" equal="9">
            <dimref name="Ziffern" role="on">
                <allpoints />
            </dimref>
            <dimref name="Blöcke" role="for">
                <allpoints />
            </dimref>
        </condition>
    </conditions>
</zeitgeist>`;
